export default __webpack_public_path__ + "static/media/edit-icon.d3b69ef4.svg";